var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9H4V20H8V9Z",
    fill: "#101323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4H4V8H8V4Z",
    fill: "#101323"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 7H10V11H14V7Z",
    fill: "#101323"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10H16V14H20V10Z",
    fill: "#101323"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15H16V20H20V15Z",
    fill: "#101323"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12H10V20H14V12Z",
    fill: "#101323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBars);
export default __webpack_public_path__ + "static/media/iconBars.8e6293ea.svg";
export { ForwardRef as ReactComponent };